import { render, staticRenderFns } from "./ModalEditAutonomousSeller.vue?vue&type=template&id=c4136ac4&scoped=true"
import script from "./ModalEditAutonomousSeller.vue?vue&type=script&lang=js"
export * from "./ModalEditAutonomousSeller.vue?vue&type=script&lang=js"
import style0 from "./ModalEditAutonomousSeller.vue?vue&type=style&index=0&id=c4136ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4136ac4",
  null
  
)

export default component.exports